import { render, staticRenderFns } from "./SnippetWidget.vue?vue&type=template&id=9dea7c6e&scoped=true"
import script from "./SnippetWidget.vue?vue&type=script&lang=js"
export * from "./SnippetWidget.vue?vue&type=script&lang=js"
import style0 from "./SnippetWidget.vue?vue&type=style&index=0&id=9dea7c6e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9dea7c6e",
  null
  
)

export default component.exports